import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {inject} from 'mobx-react';

const shopListItemClosedTag = {
    "margin": "auto",
    "fontSize": "1.25em",
    "letterSpacing": ".5pt",
    "fontFamily": "GraphikMedium"
};

@inject('RootStore')
export default class ShopListItemClosedBox extends Component {
    render() {
        let shopListItemClosedBoxStyle = {
            "color": "white",
            "textAlign": "center",
            "borderRadius": "0 50% 50% 0",
            "height": "100%"
        };
        shopListItemClosedBoxStyle.backgroundColor = this.props.RootStore.styleStore.currentStylesDict.shopListEtaBoxClosedColor;
        return (
            <Flexbox flexGrow={1} style={shopListItemClosedBoxStyle}>
                <div style={shopListItemClosedTag}>
                    Closed
                </div>
            </Flexbox>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_closed_box.jsx